var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"mask-box",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"close-btn",on:{"click":_vm.handleClose}},[_vm._v("x")]),_vm._v(" "),_c('SubscribeBox')],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-901e1600","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscribe-mask.vue
// module id = null
// module chunks = 